export default "__VITE_ASSET__Ci9MPBBm__"